import { FileSearch } from 'lucide-react'
import { type ReactNode, useState } from 'react'
import { Button } from '@/components/ui/button'
import { CaseEvidence } from '@/features/evidence/CaseEvidence'

export function EvidenceReferenceButton({
  caseId,
  referenceId,
  children,
}: {
  caseId: string
  referenceId: string
  children?: ReactNode
}) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="h-auto max-w-full gap-2 whitespace-normal text-left"
        aria-expanded={open}
        onClick={() => setOpen(value => !value)}
      >
        <FileSearch className="size-4 shrink-0" />
        {children ?? 'Preview source rows'}
      </Button>
      {open && (
        <span className="block min-w-0 py-2">
          <CaseEvidence caseId={caseId} referenceId={referenceId} />
        </span>
      )}
    </>
  )
}

export function FindingEvidence({ caseId, references }: { caseId: string; references?: string[] }) {
  if (!references?.length) return null
  return (
    <div className="flex flex-wrap gap-2">
      {references.map((id, index) => (
        <EvidenceReferenceButton key={id} caseId={caseId} referenceId={id}>
          Source evidence {index + 1}
        </EvidenceReferenceButton>
      ))}
    </div>
  )
}
